import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Calendar, Clock, Headset, Video } from 'lucide-react'

export function ConnectPage() {
  return (
    <div className="h-full overflow-auto p-6">
      <div className="w-full">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Connect Live</h1>
          <p className="text-muted-foreground">
            Schedule a session with one of our career consultants for personalized guidance.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <Card>
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <Video className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <CardTitle>Video Consultation</CardTitle>
                  <CardDescription>30-minute one-on-one session</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-4">
                Get face-to-face guidance on resume review, interview prep, or career planning from
                an experienced consultant.
              </p>
              <Button className="w-full" disabled>
                <Calendar className="mr-2 h-4 w-4" />
                Coming Soon
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <Headset className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <CardTitle>Phone Call</CardTitle>
                  <CardDescription>15-minute quick session</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-4">
                Have a quick question or need immediate support? Schedule a brief phone call with a
                consultant.
              </p>
              <Button className="w-full" disabled>
                <Clock className="mr-2 h-4 w-4" />
                Coming Soon
              </Button>
            </CardContent>
          </Card>
        </div>

        <Card className="mt-6">
          <CardHeader>
            <CardTitle>Need Help Now?</CardTitle>
            <CardDescription>
              Our coach is available 24/7 to help with your questions
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" asChild>
              <a href="/chat">Chat with Coach</a>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
